import { create } from 'zustand';
import type { ClockSnapshot, ClockPhase, WeatherKind } from '@/network/messages';

interface ClockState {
  snapshot: ClockSnapshot | null;
  serverOffsetMs: number;
  setSnapshot: (snap: ClockSnapshot) => void;
  getNow: () => { hour: number; minute: number; second: number; phase: ClockPhase; weather: WeatherKind } | null;
}

function phaseOf(hour: number): ClockPhase {
  if (hour >= 5 && hour < 7) return 'dawn';
  if (hour >= 7 && hour < 18) return 'day';
  if (hour >= 18 && hour < 20) return 'dusk';
  return 'night';
}

export const useClockStore = create<ClockState>((set, get) => ({
  snapshot: null,
  serverOffsetMs: 0,
  setSnapshot: (snap) => {
    const offset = snap.serverMs - Date.now();
    set({ snapshot: snap, serverOffsetMs: offset });
  },
  getNow: () => {
    const s = get().snapshot;
    if (!s) return null;
    const nowMs = Date.now() + get().serverOffsetMs;
    const d = new Date(nowMs);
    // Use server-derived date components by reconstructing via offset from last snapshot.
    // Server tells us hour/minute/second at serverMs; advance locally by elapsed ms.
    const elapsed = nowMs - s.serverMs;
    const totalSec = s.hour * 3600 + s.minute * 60 + s.second + Math.floor(elapsed / 1000);
    const sec = ((totalSec % 86400) + 86400) % 86400;
    const hour = Math.floor(sec / 3600);
    const minute = Math.floor((sec % 3600) / 60);
    const second = sec % 60;
    void d;
    return { hour, minute, second, phase: phaseOf(hour), weather: s.weather };
  },
}));

export function ingestClockSnapshot(snap: ClockSnapshot | undefined | null): void {
  if (!snap) return;
  useClockStore.getState().setSnapshot(snap);
}
